/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Button } from "devextreme-react/button";
import LoadPanel from "devextreme-react/load-panel";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { formatMessage } from "devextreme/localization";
import notify from "devextreme/ui/notify";
import { useDispatch, useSelector } from "react-redux";
import {
  getLeaveSummary,
  showSymbol,
  IsPermisionPathRequired,
  getEmployeeByDeclarant,
} from "../../../redux/actions";
import {
  responseLeave,
  responseSymbol,
  responseMiddleware,
  responseEmployee,
} from "../../../redux/reducers";
import FormComponent from "./FormComponent";
import DataGridRender from "./DataGrid";
import { useScreenSize } from "../../../utils/media-query";
import { useAuth } from "../../../contexts/auth";
import { getParentPath, axios } from "../../../common";
import { validateNullOrEmpty } from "../../../middlewares/validate";
import UsingIntl from "../../../services/using_intl";
import "./style.scss";

export default function LeaveRegistrationCreate() {
  const formData = useRef({
    StartTime: "",
    EndTime: "",
  });
  const dispatch = useDispatch();
  const history = useHistory();
  const { isXSmall, isSmall } = useScreenSize();
  const { user } = useAuth();
  const { leaveSummary } = useSelector(responseLeave);
  const { symbol } = useSelector(responseSymbol);
  const [employeeOid, setEmployeeOid] = useState(user?.EmployeeOid);
  const { employeesDeclarant, loadingEmployee } = useSelector(responseEmployee);
  const { middlewarePath: middleware, loading } =
    useSelector(responseMiddleware);
  const [isDisable, setIsDisable] = useState(false);
  const PARENT_PATH = getParentPath();

  useEffect(() => {
    UsingIntl("P0014");
    dispatch(IsPermisionPathRequired(PARENT_PATH));
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { NavigateState, CreateState, ReadState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (CreateState !== undefined && !CreateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
      if (!user.EmployeeOid) {
        window.location.reload();
        return;
      }
      dispatch(getLeaveSummary(user?.EmployeeOid));
      dispatch(showSymbol());
      dispatch(getEmployeeByDeclarant(user?.EmployeeOid));
    }
  }, [middleware]);

  const handleSaveRegistration = async () => {
    if (!isDisable) {
      setIsDisable(true);

      const payload = {
        ...formData.current,
        EmployeeOid: employeeOid,
      };
      const validate = {
        LeaveType: payload.LeaveType,
        FromDate: payload.FromDate,
        ToDate: payload.ToDate,
        SymbolOid: payload.SymbolOid,
      };
      const isNull = validateNullOrEmpty(validate);
      if (isNull) {
        notify("Please fill all fields", "warning", 3000);
        setIsDisable(false);
        return;
      }
      try {
        const { data } = await axios.post("LeaveRegistration", payload, {
          headers: {
            MappedState: 1,
          },
        });
        // const error = SplitErrorCode(data.value);
        // console.log(error);
        if (!data) {
          notify("Registration has not been saved", "error", 3000);
          setIsDisable(false);
          return;
        }
        setIsDisable(false);
        notify("Registration has been saved", "success", 3000);
        history.push("/leave/leave-registration/list");
      } catch (error) {
        setIsDisable(false);
        notify(error.response.data.message, error.response.data.msgType, 3000);
        // console.log(error);
      }
    }
  };

  return (
    <div>
      {loadingEmployee && <LoadPanel visible={loadingEmployee} />}
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("LeaveRegistrationCreate")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/leave-registration/list" className={"breadcrumb-item"}>
            {formatMessage("Leave")}
          </Link>
          <Link to="/leave-registration/list" className={"breadcrumb-item"}>
            {formatMessage("LeaveRegistration")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("Create")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-heading has-page-title"}>
          <h4 className={"page-title"}>
            {user?.EmployeeCode + " - " + user?.EmployeeName}
          </h4>
          <div className={`page-actions`}>
            <Toolbar>
              <Item
                location="after"
                locateInMenu={isXSmall || isSmall ? "always" : "auto"}
                cssClass={"datagrid-toolbar-actions-dropdown"}
              >
                <Button
                  icon="check"
                  text={formatMessage("Save")}
                  onClick={handleSaveRegistration}
                  type="default"
                  disabled={isDisable}
                  className="mr-1"
                  stylingMode="outlined"
                />
                <Button
                  icon="close"
                  text={formatMessage("Cancel")}
                  onClick={() => history.push("/leave/leave-registration/list")}
                  stylingMode="outlined"
                />
              </Item>
            </Toolbar>
          </div>
        </div>
        <div className={"section-body"}>
          <FormComponent
            formData={formData}
            user={user}
            symbol={symbol}
            employee={employeesDeclarant}
            setEmployeeOid={setEmployeeOid}
            employeeOid={employeeOid}
          />
          <DataGridRender dataTable={leaveSummary} />
        </div>
      </div>
    </div>
  );
}
